(function () {'use strict';}());
angular.module("elidb").directive('profileView', function($document,$timeout) {
    return {
      restrict: 'A',
      templateUrl: __DIR__+'/views/profile.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.PANEL_AGE = 1;
        $scope.PANEL_DIAGNOSIS = 2;
        $scope.PANEL_INSURANCE = 3;
        $scope.PANEL_LANGUAGE = 4;
        $scope.PANEL_SERVICES = 5;
        $scope.currentItem = null;

        $scope.currentPanel = $scope.PANEL_AGE;
        $scope.selectionModel = {services: {}};

        $scope.setCurrentEggState("Age");

        $scope.$watch("tagLookup",onTagsSet);
        $scope.$watch("currentPage",onPageSet);
        $document.on("click",onDocumentClick);
        $document.on("keydown",onKeyDown);

        function onTagsSet(value) {
        	if(!value || angular.equals({}, value)) return;
            
        	$scope.age = angular.copy($scope.tagLookup.age);
        	$scope.diagnosis = ([{id: -1, label: $scope.tech.txtProfileNoDK ? $scope.tech.txtProfileNoDK.value  : 'No / I don&apos;t know'},
        	 					{id: -2, label: $scope.tech.txtProfileDontSee ? $scope.tech.txtProfileDontSee.value : 'I don&apos;t see my diagnosis here'}])
        	 				.concat(angular.copy($scope.tagLookup.diagnosis));
        	$scope.insurance = [{id: 1, label: $scope.tech.txtSurvYes.value}, {id: 2, label: $scope.tech.txtSurvNo.value}];
        	$scope.language = [{id: 1, label: $scope.tech.txtSurvYes.value}, {id: 2, label: $scope.tech.txtSurvNo.value}];

        	$scope.services = angular.copy($scope.categoryLookup.Service.subs.concat());

            trace($scope.services);
            //$scope.selectionModel.language =  $scope.language[1];
        }

        function onKeyDown(e) {
            if(e.keyCode !== 27 || $scope.currentPage !== $scope.PROFILE_PAGE || !$scope.currentItem) return;
            $scope.$apply(closeAllItems);
        }

        function onPageSet(value) {
            if(value === $scope.PROFILE_PAGE) {
                $scope.currentPanel = $scope.PANEL_AGE;
                $scope.setCurrentEggState("Age");
            }
        }

        function onDocumentClick(e) {
            if($scope.currentPage !== $scope.PROFILE_PAGE || !$scope.currentItem) return;
            var $target = $(e.target);
            var inMenu = $target.closest(".ul.primary").length;
            if(inMenu) return;
            $scope.$apply(closeAllItems);
        }

        $scope.setCurrentPanel = function(value) {
        	if(value === 0) return $scope.setCurrentPage($scope.LANDING_PAGE);
        	if(value > $scope.PANEL_SERVICES) return synthesizeSelections();
        	$scope.currentPanel = value;
            var name = null;

            switch(value) {
                case 1:
                    name = "Age";
                break;
                case 2:
                    name = "Diagnosis";
                break;
                case 3:
                    name = "Insurance";
                break;
                case 4:
                    name = "Language";
                break;
                case 5:
                    name = "Services";
                break;
                default:
            }

            trace(name);

            $scope.setCurrentEggState(name);
        };

        $scope.getPercentageCompletion = function(token) {
        	if(!token) return null;

        	var percentage = Math.ceil(100 * ($scope.currentPanel) / ($scope.PANEL_SERVICES + 1));
        	return token.replace(/\$\{percent\}/gim, percentage);
        };

        $scope.nextButtonIsDisabled = function() {
        	var model = $scope.selectionModel[getCurrentPanelName()];
        	for(var prop in model) {
        		if(model[prop]) return false;
        	}
        	return true;

        };

        $scope.toggleItem = function(item) {
            closeAllItems(item);

            item.expand = item.expand ? false : true;
            if(item.expand) $scope.currentItem = item;
        };

        function closeAllItems(except) {
            $scope.currentItem = null;
            $scope.services.forEach(function(e){
                if(angular.equals(e,except)) return;
                e.expand = false;
            });
        }

        $scope.navButtonIsDisabled = function(value) {
        	var keys = ["location","age","diagnosis","insurance","language","services"];
        	for(var i = 1; i < value; i++) {
        		var model = $scope.selectionModel[keys[i]];
        		var panelSatisfied = false;

        		for(var prop in model) {
	        		if(model[prop]) panelSatisfied = true;
	        	}

	        	if(!panelSatisfied) return true;
        	}

        	return false;

        };

        function getCurrentPanelName() {
        	for(var prop in $scope) {
        		if(!prop.match(/PANEL_/gim)) continue;
        		if($scope[prop] === $scope.currentPanel) return prop.replace(/PANEL_/gim,"").toLowerCase();
        	}
        	return null;
        }

        function synthesizeSelections() {
        	var lookup = $scope.tagDictionary;
        	var search = {zip: $scope.filters.zip, radius: $scope.filters.radius};
            //"location","age","diagnosis"
        	var keys = ["services"];
        	for(var i = 0; i < keys.length; i++) {
        		var model = $scope.selectionModel[keys[i]];
        		var key = keys[i] === "services" ? "filters" : keys[i];
        		search[key] = {};

        		for(var prop in model) {
	        		if(!model[prop] || model[prop].id < 1) continue;
	        		var tag = lookup[model[prop].id];
	        		search[key][model[prop].id] = true;
	        	}
        	}

            if($scope.selectionModel.age) {
                search.age = {};
                search.age[$scope.selectionModel.age.id] = true;
            }
            
            if($scope.selectionModel.diagnosis) {
                search.diagnosis = {};
                search.diagnosis[$scope.selectionModel.diagnosis.id] = true;
            }

            if($scope.selectionModel.insurance && $scope.selectionModel.insurance.id === 1) {
                search.filters[__STATE__ == "MA" ? 58 : 97] = true;
            }

            if($scope.selectionModel.language && $scope.selectionModel.language.id === 1) {
                search.filters[110] = true;
            }

            __LOADED_SEARCH__ = search;
            $scope.setReady(true);
            $scope.setCurrentPage($scope.REFINE_PAGE);
            $scope.currentPanel = 0;
        }

        $scope.skipProfile = function() {
            synthesizeSelections();
        };
      }  
    };
  });